import FIELDS_EMPLOYEE from '@/helpers/field-definitions.json';
import { Button } from '@/platform/ui';
import { PlusIcon } from '@heroicons/react/24/outline';
import { useMemo } from 'react';
import Rule from './Rule';

const Rules = ({ data, onChange }) => {
    const handleAdd = type => {
        onChange('rules', [
            ...(data?.rules || []),
            {
                id: Date.now(),
                type,
                value_type: 'field',
                field: '',
                operator: '',
                value: '',
                children: [],
            },
        ]);
    };

    const handleRemove = id => {
        onChange(
            'rules',
            data?.rules?.filter(rule => rule?.id !== id)
        );
    };

    const handleChange = (id, field, value) => {
        onChange(
            'rules',
            data?.rules?.map(rule => {
                if (rule.id === id) {
                    return {
                        ...rule,
                        [field]: value,
                    };
                }

                return rule;
            })
        );
    };

    const fields = useMemo(() => {
        const data = FIELDS_EMPLOYEE['LKV scan'];
        const options = [];

        Object.keys(data).map(key => {
            options.push({ id: key, name: data[key].label });
        });

        return options;
    }, []);

    return (
        <>
            <div className='mt-4 flex items-center justify-end gap-4'>
                <Button type='button' onClick={() => handleAdd('rule')}>
                    <PlusIcon className='size-5' />
                    Regel toevoegen
                </Button>
                <Button type='button' onClick={() => handleAdd('statement:if')}>
                    <PlusIcon className='size-5' />
                    Statement toevoegen
                </Button>
            </div>

            {data?.rules?.map(rule => (
                <Rule
                    rule={rule}
                    key={rule.id}
                    onChange={handleChange}
                    onRemove={handleRemove}
                    fields={fields}
                />
            ))}
        </>
    );
};

export default Rules;
